export default {
	data() {
		return {};
	},
	computed: {
		browserInfo() {
			const me = this;
			//Lấy thông tin từ trong thư viện commonFunc
			return me.$ms.commonFunc.getBrowserInfo();
		}
	},
	methods: {},
	mounted() {},
	beforeDestroy() {}
};
